export const COMPETITION_GETTERS = Object.freeze({
    COMPETITIONS: "competitions",
    USER_COMPETITIONS: "userCompetitions",
    ENTITIES: "entities",
    SELECTED_COMPETITIONS: "selectedCompetitions",
    GROUPED_COMPETITIONS: "groupedCompetitions",
    GET_SELECTED_COMPETITIONS: "getSelectedCompetition"
});
